<template>
  <div>
    <a href="javascript:void(0)" @click="changeListShowStatus">
      <span>{{ currentLang.text }}</span>
      <span :class="['caret', {'caret-up': showLangList}]"></span>
    </a>
    <template v-if="showLangList">
      <p v-for="lang in languages" v-show="lang !== currentLang" @click="changeLang(lang)">
        {{ lang.text }}
      </p>
    </template>
  </div>
</template>

<script>
  import languages from '../../lib/i18n'
  import { funcUrlDel } from '../../lib/utils'
  import { mapState } from 'vuex'

  export default {
    name: 'choose-lang-in-m',
    data() {
      return {
        currentLang: {
          'code': '',
          'text': ''
        },
        showLangList: false,
        languages
      }
    },
    computed: {
      ...mapState({
        language: state => state.currentLang,
        specialHeader: state => state.header.specialHeader
      })
    },
    created() {
      this.getInitLang()
    },
    methods: {
      changeListShowStatus() {
        this.showLangList = !this.showLangList
      },
      getInitLang() {
        this.currentLang.code = this.$store.state.currentLang
        this.matchLang()
      },
      matchLang() {
        for (let i = 0; i < this.languages.length; i++) {
          if (this.languages[i].code === this.currentLang.code) {
            this.currentLang = this.languages[i]
          }
        }
      },
      changeLang(lang) {
        this.currentLang.code = lang.code
        this.matchLang()
        this.$store.commit('setCurrentLang', lang.code)
        window.sessionStorage.setItem('needUseNoCache', true)
        window.location.replace(funcUrlDel('lang'))
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .caret-up {
    transform: rotate(180deg);
  }

  div {
    font-size: 0;
    padding: .1rem 0;
  }

  a {
    display: block;
    width: 100%;
  }

  a, a:hover, a:focus {
    outline: none;
  }

  a, p {
    line-height: .4rem;
    font-size: .16rem;
    color: #333333;
    letter-spacing: .38px;
  }
</style>



// WEBPACK FOOTER //
// ChooseLangInM.vue?d6df9d14